import { render, staticRenderFns } from "./fund-source-id.vue?vue&type=template&id=24bfc524&"
import script from "./fund-source-id.vue?vue&type=script&lang=js&"
export * from "./fund-source-id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports